// src/components/pages/HomepageCarousel.jsx
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel'; // adjust path if needed

export default function HomepageCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/Garden/garden 1.jpg`, alt: 'Garden 1' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 1.jpg`, alt: 'Rec 1' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 2.jpg`, alt: 'Hayloft 2' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 1.jpg`, alt: 'Kitchen 1' },
      { src: `${process.env.PUBLIC_URL}/images/kitchen/kitchen 2.jpg`, alt: 'Kitchen 2' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 2.jpg`, alt: 'Rec 2' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 7.jpg`, alt: 'Hayloft 7' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording top carousel/rec 3.jpg`, alt: 'Rec 3' },
      { src: `${process.env.PUBLIC_URL}/images/hayloft/hayloft 6.jpg`, alt: 'Hayloft 6' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.1.jpg`, alt: 'Labs 1.1' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.2.jpg`, alt: 'Labs 1.2' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.3.jpg`, alt: 'Labs 1.3' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 5.jpg`, alt: 'Courtyard 5' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 6.jpg`, alt: 'Courtyard 6' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 7.jpg`, alt: 'Courtyard 7' },
      { src: `${process.env.PUBLIC_URL}/images/Courtyard/courtyard 9.jpg`, alt: 'Courtyard 9' },
    ],
    []
  );

  return (
    <CrossfadeCarousel
      slides={slides}
      aspectRatio="3/2"
      delay={5000}
    />
  );
}
